import fileUploadSubmit from '../../helpers/fileUploadSubmit'
import filePutSubmit from '../../helpers/filePutSubmit'
import jsonUploadSubmit from '../../helpers/jsonUploadSubmit'
import jsonPutSubmit from '../../helpers/jsonPutSubmit'
import { login } from '../../../store/actions/auth'

export const sendDataUpload = async function (endPoint, pageReload, thisProp) {
    await thisProp.setState({ sending: true })
    await fileUploadSubmit(thisProp.state, thisProp.refs, endPoint)
        .then(async res => {
            if (res.data === "resim ya da dosya yüklenmemiş") {
                await thisProp.setState({ sending: false, errorMessage: "Resimlerden ya da dosyalardan birisi yüklenmemiş" })
            } else {
                thisProp.props.history.push(pageReload)
            }
        })
        .catch(async err => {
            if (err.message === "Request failed with status code 401") {
                login("")
            }
            await thisProp.setState({ sending: false })
        })
}
export const changeDataUpload = async function (endPoint, pageReload, thisProp) {
    await thisProp.setState({ sending: true })
    await filePutSubmit(thisProp.state, thisProp.refs, endPoint + thisProp.state.id)
        .then(async res => {
            if (res.data === "resim ya da dosya yüklenmemiş") {
                await thisProp.setState({ sending: false, errorMessage: "Resimlerden ya da dosyalardan birisi yüklenmemiş" })
            } else {
                thisProp.props.history.push(pageReload)
            }
        })
        .catch(async err => {
            if (err.message === "Request failed with status code 401") {
                login("")
            }
            await thisProp.setState({ sending: false })
        })
}

export const sendDataJson = async function (endPoint, pageReload, thisProp) {
    await thisProp.setState({ sending: true })
    await jsonUploadSubmit(thisProp.state, thisProp.refs, endPoint)
        .then(async res => {
            if (res.data === "resim ya da dosya yüklenmemiş") {
                await thisProp.setState({ sending: false, errorMessage: "Resimlerden ya da dosyalardan birisi yüklenmemiş" })
            } else {
                thisProp.props.history.push(pageReload)
            }
        })
        .catch(async err => {
            if (err.message === "Request failed with status code 401") {
                login("")
            }
            await thisProp.setState({ sending: false })
        })
}
export const changeDataJson = async function (endPoint, pageReload, thisProp) {
    await thisProp.setState({ sending: true })
    await jsonPutSubmit(thisProp.state, thisProp.refs, endPoint + thisProp.state.id)
        .then(async res => {
            if (res.data === "resim ya da dosya yüklenmemiş") {
                await thisProp.setState({ sending: false, errorMessage: "Resimlerden ya da dosyalardan birisi yüklenmemiş" })
            } else {
                thisProp.props.history.push(pageReload)
            }
        })
        .catch(async err => {
            if (err.message === "Request failed with status code 401") {
                login("")
            }
            await thisProp.setState({ sending: false })
        })
}
